export default function JoinUs(props: any) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="150" height="100" viewBox="0 0 150 100" fill="none">
            <g clipPath="url(#clip0_29_6290)">
                <g filter="url(#filter0_d_29_6290)">
                    <g filter="url(#filter1_ddi_29_6290)">
                        <ellipse
                            cx="64.2856"
                            cy="15.9047"
                            rx="64.2856"
                            ry="15.9047"
                            transform="matrix(0.998385 0.00766407 -0.0119995 1.00151 10.9399 43.7598)"
                            stroke="url(#paint0_linear_29_6290)"
                            strokeWidth="4.60037"
                            strokeLinecap="round"
                            shapeRendering="crispEdges"
                        />
                    </g>
                </g>
                <g filter="url(#filter2_ii_29_6290)">
                    <circle cx="102.752" cy="41.2395" r="9.74409" fill="url(#paint1_linear_29_6290)" />
                </g>
                <circle cx="102.752" cy="41.2395" r="9.16904" stroke="url(#paint2_linear_29_6290)" strokeWidth="1.15009" />
                <g filter="url(#filter3_ii_29_6290)">
                    <path
                        d="M90.4287 61.507C91.5012 57.0024 95.5261 53.8232 100.157 53.8232L105.619 53.8232C110.25 53.8232 114.275 57.0024 115.347 61.507L119.444 78.7118C120.94 84.9955 116.175 91.028 109.716 91.028L96.0604 91.028C89.601 91.028 84.8362 84.9955 86.3323 78.7117L90.4287 61.507Z"
                        fill="url(#paint3_linear_29_6290)"
                    />
                </g>
                <path
                    d="M90.9881 61.6402C91.999 57.3946 95.7924 54.3983 100.157 54.3983L105.619 54.3983C109.984 54.3983 113.777 57.3946 114.788 61.6402L118.884 78.8449C120.295 84.7674 115.804 90.4529 109.716 90.4529L96.0604 90.4529C89.9724 90.4529 85.4816 84.7673 86.8917 78.8449L90.9881 61.6402Z"
                    stroke="url(#paint4_linear_29_6290)"
                    strokeWidth="1.15009"
                />
                <g filter="url(#filter4_ii_29_6290)">
                    <circle cx="44.0341" cy="41.2395" r="9.74409" fill="url(#paint5_linear_29_6290)" />
                </g>
                <circle cx="44.0341" cy="41.2395" r="9.16904" stroke="url(#paint6_linear_29_6290)" strokeWidth="1.15009" />
                <g filter="url(#filter5_ii_29_6290)">
                    <path
                        d="M31.7109 61.507C32.7835 57.0024 36.8084 53.8232 41.439 53.8232L46.9016 53.8232C51.5322 53.8232 55.5572 57.0024 56.6297 61.507L60.7261 78.7118C62.2222 84.9955 57.4574 91.028 50.998 91.028L37.3426 91.028C30.8832 91.028 26.1184 84.9955 27.6146 78.7117L31.7109 61.507Z"
                        fill="url(#paint7_linear_29_6290)"
                    />
                </g>
                <path
                    d="M32.2703 61.6402C33.2812 57.3946 37.0747 54.3983 41.439 54.3983L46.9016 54.3983C51.266 54.3983 55.0594 57.3946 56.0703 61.6402L60.1666 78.8449C61.5767 84.7674 57.086 90.4529 50.998 90.4529L37.3426 90.4529C31.2547 90.4529 26.7639 84.7673 28.174 78.8449L32.2703 61.6402Z"
                    stroke="url(#paint8_linear_29_6290)"
                    strokeWidth="1.15009"
                />
                <g filter="url(#filter6_d_29_6290)">
                    <g filter="url(#filter7_ii_29_6290)">
                        <circle cx="72.9856" cy="19.1409" r="14.1409" fill="url(#paint9_linear_29_6290)" />
                    </g>
                    <circle cx="72.9856" cy="19.1409" r="13.5658" stroke="url(#paint10_linear_29_6290)" strokeWidth="1.15009" />
                    <g filter="url(#filter8_ii_29_6290)">
                        <path
                            d="M55.9943 45.8324C57.0291 41.2795 61.0767 38.0486 65.7457 38.0486L80.4941 38.0486C85.1631 38.0486 89.2107 41.2795 90.2454 45.8324L98.4971 82.1395C99.9192 88.3972 95.1629 94.3557 88.7457 94.3557L57.4941 94.3557C51.0768 94.3557 46.3205 88.3972 47.7427 82.1395L55.9943 45.8324Z"
                            fill="url(#paint11_linear_29_6290)"
                        />
                    </g>
                    <path
                        d="M56.5551 45.9598C57.5303 41.6687 61.3452 38.6236 65.7457 38.6236L80.4941 38.6236C84.8946 38.6236 88.7094 41.6687 89.6847 45.9598L97.9363 82.267C99.2767 88.1648 94.7939 93.7807 88.7457 93.7807L57.4941 93.7807C51.4459 93.7807 46.9631 88.1648 48.3035 82.267L56.5551 45.9598Z"
                        stroke="url(#paint12_linear_29_6290)"
                        strokeWidth="1.15009"
                    />
                </g>
                <g filter="url(#filter9_ddi_29_6290)">
                    <path
                        d="M37.6515 72.6051C48.2527 74.7892 61.59 76.1437 76.0909 76.2551C110.75 76.5213 138.933 69.585 139.038 60.7623C139.07 58.1115 136.564 55.592 132.101 53.357"
                        stroke="url(#paint13_linear_29_6290)"
                        strokeWidth="4.60037"
                        strokeLinecap="round"
                    />
                </g>
            </g>
            <defs>
                <filter
                    id="filter0_d_29_6290"
                    x="5.88542"
                    y="41.9409"
                    width="138.091"
                    height="41.6139"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset dy="2.56673" />
                    <feGaussianBlur stdDeviation="1.28336" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_29_6290" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_29_6290" result="shape" />
                </filter>
                <filter
                    id="filter1_ddi_29_6290"
                    x="3.85178"
                    y="40.2743"
                    width="142.158"
                    height="47.3479"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset dy="4.60037" />
                    <feGaussianBlur stdDeviation="2.30018" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_29_6290" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset dy="1.66667" />
                    <feGaussianBlur stdDeviation="1.66667" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                    <feBlend mode="normal" in2="effect1_dropShadow_29_6290" result="effect2_dropShadow_29_6290" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_29_6290" result="shape" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset dy="1.22047" />
                    <feGaussianBlur stdDeviation="3.05118" />
                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.69 0" />
                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_29_6290" />
                </filter>
                <filter
                    id="filter2_ii_29_6290"
                    x="89.6745"
                    y="30.662"
                    width="26.2719"
                    height="23.7719"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset dx="3.45028" dy="3.45028" />
                    <feGaussianBlur stdDeviation="2.30018" />
                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0" />
                    <feBlend mode="normal" in2="shape" result="effect1_innerShadow_29_6290" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset dx="-3.33333" dy="-0.833333" />
                    <feGaussianBlur stdDeviation="2.08333" />
                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0.15 0 0 0 0 0.15 0 0 0 0 0.15 0 0 0 0.25 0" />
                    <feBlend mode="normal" in2="effect1_innerShadow_29_6290" result="effect2_innerShadow_29_6290" />
                </filter>
                <filter
                    id="filter3_ii_29_6290"
                    x="82.7223"
                    y="52.9899"
                    width="40.4482"
                    height="41.4882"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset dx="3.45028" dy="3.45028" />
                    <feGaussianBlur stdDeviation="2.30018" />
                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0" />
                    <feBlend mode="normal" in2="shape" result="effect1_innerShadow_29_6290" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset dx="-3.33333" dy="-0.833333" />
                    <feGaussianBlur stdDeviation="2.08333" />
                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0.15 0 0 0 0 0.15 0 0 0 0 0.15 0 0 0 0.25 0" />
                    <feBlend mode="normal" in2="effect1_innerShadow_29_6290" result="effect2_innerShadow_29_6290" />
                </filter>
                <filter
                    id="filter4_ii_29_6290"
                    x="30.9567"
                    y="30.662"
                    width="26.2719"
                    height="23.7719"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset dx="3.45028" dy="3.45028" />
                    <feGaussianBlur stdDeviation="2.30018" />
                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0" />
                    <feBlend mode="normal" in2="shape" result="effect1_innerShadow_29_6290" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset dx="-3.33333" dy="-0.833333" />
                    <feGaussianBlur stdDeviation="2.08333" />
                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0.15 0 0 0 0 0.15 0 0 0 0 0.15 0 0 0 0.25 0" />
                    <feBlend mode="normal" in2="effect1_innerShadow_29_6290" result="effect2_innerShadow_29_6290" />
                </filter>
                <filter
                    id="filter5_ii_29_6290"
                    x="24.0046"
                    y="52.9899"
                    width="40.4482"
                    height="41.4882"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset dx="3.45028" dy="3.45028" />
                    <feGaussianBlur stdDeviation="2.30018" />
                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0" />
                    <feBlend mode="normal" in2="shape" result="effect1_innerShadow_29_6290" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset dx="-3.33333" dy="-0.833333" />
                    <feGaussianBlur stdDeviation="2.08333" />
                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0.15 0 0 0 0 0.15 0 0 0 0 0.15 0 0 0 0.25 0" />
                    <feBlend mode="normal" in2="effect1_innerShadow_29_6290" result="effect2_innerShadow_29_6290" />
                </filter>
                <filter
                    id="filter6_d_29_6290"
                    x="45.8231"
                    y="3.33333"
                    width="57.9269"
                    height="96.0224"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset dx="1.66667" dy="1.66667" />
                    <feGaussianBlur stdDeviation="1.66667" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_29_6290" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_29_6290" result="shape" />
                </filter>
                <filter
                    id="filter7_ii_29_6290"
                    x="55.5114"
                    y="4.16667"
                    width="35.0653"
                    height="32.5653"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset dx="3.45028" dy="3.45028" />
                    <feGaussianBlur stdDeviation="2.30018" />
                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0" />
                    <feBlend mode="normal" in2="shape" result="effect1_innerShadow_29_6290" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset dx="-3.33333" dy="-0.833333" />
                    <feGaussianBlur stdDeviation="2.08333" />
                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0.15 0 0 0 0 0.15 0 0 0 0 0.15 0 0 0 0.25 0" />
                    <feBlend mode="normal" in2="effect1_innerShadow_29_6290" result="effect2_innerShadow_29_6290" />
                </filter>
                <filter
                    id="filter8_ii_29_6290"
                    x="44.1564"
                    y="37.2153"
                    width="58.0439"
                    height="60.5907"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset dx="3.45028" dy="3.45028" />
                    <feGaussianBlur stdDeviation="2.30018" />
                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0" />
                    <feBlend mode="normal" in2="shape" result="effect1_innerShadow_29_6290" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset dx="-3.33333" dy="-0.833333" />
                    <feGaussianBlur stdDeviation="2.08333" />
                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0.15 0 0 0 0 0.15 0 0 0 0 0.15 0 0 0 0.25 0" />
                    <feBlend mode="normal" in2="effect1_innerShadow_29_6290" result="effect2_innerShadow_29_6290" />
                </filter>
                <filter
                    id="filter9_ddi_29_6290"
                    x="30.7541"
                    y="49.3861"
                    width="115.182"
                    height="38.3808"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset dy="4.60037" />
                    <feGaussianBlur stdDeviation="2.30018" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_29_6290" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset dy="1.66667" />
                    <feGaussianBlur stdDeviation="1.66667" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                    <feBlend mode="normal" in2="effect1_dropShadow_29_6290" result="effect2_dropShadow_29_6290" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_29_6290" result="shape" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset dy="1.22047" />
                    <feGaussianBlur stdDeviation="3.05118" />
                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.69 0" />
                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_29_6290" />
                </filter>
                <linearGradient id="paint0_linear_29_6290" x1="64.2856" y1="0" x2="64.2856" y2="31.8095" gradientUnits="userSpaceOnUse">
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="#9E9E9E" />
                </linearGradient>
                <linearGradient id="paint1_linear_29_6290" x1="100.732" y1="29.5702" x2="109.56" y2="49.0647" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#D9D9D9" />
                    <stop offset="1" stopColor="#A3A3A3" />
                </linearGradient>
                <linearGradient id="paint2_linear_29_6290" x1="96.1921" y1="26.835" x2="109.066" y2="25.0769" gradientUnits="userSpaceOnUse">
                    <stop stopColor="white" />
                    <stop offset="0.51498" stopColor="#979797" />
                    <stop offset="1" stopColor="#BEBEBE" />
                </linearGradient>
                <linearGradient id="paint3_linear_29_6290" x1="98.8483" y1="50.148" x2="115.182" y2="87.936" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#D9D9D9" />
                    <stop offset="1" stopColor="#A3A3A3" />
                </linearGradient>
                <linearGradient id="paint4_linear_29_6290" x1="97.2675" y1="34.7397" x2="132.801" y2="38.7487" gradientUnits="userSpaceOnUse">
                    <stop stopColor="white" />
                    <stop offset="0.51498" stopColor="#979797" />
                    <stop offset="1" stopColor="#BEBEBE" />
                </linearGradient>
                <linearGradient id="paint5_linear_29_6290" x1="42.0143" y1="29.5702" x2="50.8419" y2="49.0647" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#D9D9D9" />
                    <stop offset="1" stopColor="#A3A3A3" />
                </linearGradient>
                <linearGradient id="paint6_linear_29_6290" x1="37.4744" y1="26.835" x2="50.348" y2="25.0769" gradientUnits="userSpaceOnUse">
                    <stop stopColor="white" />
                    <stop offset="0.51498" stopColor="#979797" />
                    <stop offset="1" stopColor="#BEBEBE" />
                </linearGradient>
                <linearGradient id="paint7_linear_29_6290" x1="40.1306" y1="50.148" x2="56.4643" y2="87.936" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#D9D9D9" />
                    <stop offset="1" stopColor="#A3A3A3" />
                </linearGradient>
                <linearGradient id="paint8_linear_29_6290" x1="38.5497" y1="34.7397" x2="74.0835" y2="38.7487" gradientUnits="userSpaceOnUse">
                    <stop stopColor="white" />
                    <stop offset="0.51498" stopColor="#979797" />
                    <stop offset="1" stopColor="#BEBEBE" />
                </linearGradient>
                <linearGradient id="paint9_linear_29_6290" x1="70.0543" y1="2.20621" x2="82.8652" y2="30.497" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#D9D9D9" />
                    <stop offset="1" stopColor="#A3A3A3" />
                </linearGradient>
                <linearGradient id="paint10_linear_29_6290" x1="63.4659" y1="-1.76319" x2="82.1484" y2="-4.31463" gradientUnits="userSpaceOnUse">
                    <stop stopColor="white" />
                    <stop offset="0.51498" stopColor="#979797" />
                    <stop offset="1" stopColor="#BEBEBE" />
                </linearGradient>
                <linearGradient id="paint11_linear_29_6290" x1="67.2839" y1="32.4863" x2="92.7897" y2="88.8116" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#D9D9D9" />
                    <stop offset="1" stopColor="#A3A3A3" />
                </linearGradient>
                <linearGradient id="paint12_linear_29_6290" x1="65.0001" y1="9.16681" x2="116.391" y2="14.7013" gradientUnits="userSpaceOnUse">
                    <stop stopColor="white" />
                    <stop offset="0.51498" stopColor="#979797" />
                    <stop offset="1" stopColor="#BEBEBE" />
                </linearGradient>
                <linearGradient id="paint13_linear_29_6290" x1="88.5085" y1="53.0221" x2="88.3293" y2="76.3491" gradientUnits="userSpaceOnUse">
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="#9E9E9E" />
                </linearGradient>
                <clipPath id="clip0_29_6290">
                    <rect width="150" height="100" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}
